import { defineAgenda } from '@/shared/navigation/core';

/**
 * Agenda seznamu tras (Trasy autobusů) — kořenová agenda route `/products-chains`. Univerzální
 * ListPage (engine `@/shared/ui/list-page`, šablona `stationChainListPage.tsx`). Otevírá detail
 * jako modální vrstvu.
 */
export const stationChainListAgenda = defineAgenda({
  id: 'app.products.station-chains',
  path: 'app/products/station-chains',
  open: {},
  state: {},
  title: 'Trasy',
  icon: 'list',
});
